<template>
  <div id="page-product-details">
    <section-risk-codes-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Create Lloyds Risk Code"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'facilities.sections.riskCodes.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            :disabled="loading"
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SaveModelMixin from '@/components/mixins/SaveModelMixin';
import SectionRiskCodesForm from './SectionRiskCodesForm';

export default {
  name: "SectionRiskCodeCreate",
  components: {
    SectionRiskCodesForm,
  },
  mixins: [NotificationMixin,SaveModelMixin],
  data() {
    return {
      model: {},
      loading: false,
    };
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const references = [
        'LloydsRiskCode_FK'
      ]

      this.setReferences(references);

      params.Section_FK = this.$route.params.sectionId;

      return params;
    },
    validate() {
      return this.$refs.form.validate();
    },
    async create() {
      if (!this.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.facilities.sections.createRiskCode(
          params,
          this.$route.params.sectionId
        );
        this.notifySuccess('Risk Code created');
        await this.$router.push({ name: 'facilities.sections.riskCodes.list' })
      } catch (e) {
        this.notifyError('Section failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
